import React, { FC, useState, useEffect } from 'react';
import { Box, Divider, Grid, Typography } from '@mui/material';
import useStyles from './bulk-config/styles';
import { selectedConfigInfo, ConfigType, DeviceParameterConfigType, selectedConfig } from '../../../pages/bulk-device-management/types';

const ConfigInformation = ({
    actionType,
    subActionType
}: {
    actionType: string,
    subActionType: string,
}) => {
    const classes = useStyles();
    const [filteredConfigInfo, setFilteredConfigInfo] = useState<any[]>([]);

    const filteredData = (actionType: string, subActionType: string): any => {
        let filteredData: any[] = [];
        switch (subActionType === 'Parameter Type' ? actionType : subActionType) {
            case ConfigType.ShortCommand: {
                filteredData = selectedConfigInfo.filter(item => item.id === actionType)
                setFilteredConfigInfo(filteredData);
                return null;
            }
            case ConfigType.ShortMessage: {
                filteredData = selectedConfigInfo.filter(item => item.id === actionType)
                setFilteredConfigInfo(filteredData);
                return null;
            }
            case ConfigType.ConfigFiles: {
                filteredData = selectedConfigInfo.filter(item => item.id === actionType)
                setFilteredConfigInfo(filteredData);
                return null;
            }
            case ConfigType.DeviceWakeups: {
                filteredData = selectedConfigInfo.filter(item => item.id === actionType)
                setFilteredConfigInfo(filteredData);
                return null;
            }
            case ConfigType.ScheduleCommand: {
                filteredData = selectedConfigInfo.filter(item => item.id === actionType)
                setFilteredConfigInfo(filteredData);
                return null;
            }
            case DeviceParameterConfigType.EOD: {
                filteredData = selectedConfigInfo.filter(item => item.id === subActionType)
                setFilteredConfigInfo(filteredData);
                return null;
            }
            case DeviceParameterConfigType.TamperResistance: {
                filteredData = selectedConfigInfo.filter(item => item.id === subActionType)
                setFilteredConfigInfo(filteredData);
                return null;
            }
            default:
                return null;
        }
    }
    useEffect(() => {
        filteredData(actionType, subActionType)
    }, [actionType || subActionType])

    return (
        <Box p={2}>
            <Typography variant="h5" p={1}>
                Config Inforamtion:
            </Typography>
            <Divider />
            <Box>
                {
                    filteredConfigInfo && filteredConfigInfo.map((item: selectedConfig) => (
                        <Grid container >
                            <Grid item xs={12} md={6} lg={12} >
                                <Typography p={1} variant="h5" className={classes.configTitleTypography}>  {item.id}:</Typography>
                            </Grid>

                            {item.columnheader && item.columnheader.columns &&
                                item.columnheader.columns.map((column: any) => (

                                    <Grid item xs={12} md={6} lg={6} >
                                        <Box p={1} sx={{ display: "flex", flexDirection: "column" }}>
                                            {column && column.map((columnItem: any) => (
                                                <div style={{ display: 'flex', flexDirection: "row" }}>
                                                    <Typography pl={3} className={classes.itemTitleTypography}>{columnItem.title}:</Typography>
                                                    <Typography pl={1} >{columnItem.accessor}</Typography>
                                                </div>
                                            ))}
                                        </Box>
                                    </Grid>
                                ))}
                        </Grid>
                    ))
                }
            </Box>
        </Box>
    )
}
export default ConfigInformation;